import React, { Component } from 'react';

import Button from '../../../../common/Button/Button';
import Checkbox from '../../../../common/Checkbox/Checkbox';

import cn from 'classnames';
import styles from './Registration.scss';
import tracker from '../../../../../services/tracker';
import i18n from '../../../../../i18n';
import { withTranslation } from 'react-i18next';
import { gaEvent, trackGA } from 'services/ga';

// key - name
// 1  Юстиция
// 2  Предварительный договор
// 3  Договор инвестирования
// 4  Паевой взнос
// 5  Договор бронирования
// 6  Договор займа
// 7  Договор простого товарищества
// 8  Договор переуступки
// 9  Договор купли-продажи
// 10  Договор паенакопления
// 11  Договор о намерениях
// 12  Договор задатка
// 13  Договор подряда
// 14  ДДУ / ФЗ-214 (бывш. Договор долевого участия)

const getVariants = (t) => ({
  part: {
    param: 'part',
    key: 14,
    text: t('components.header.filtersBar.filters.registration.part'),
    event: 'Web_Filters_Part',
  },
  loan: {
    param: 'loan',
    key: 6,
    text: t('components.header.filtersBar.filters.registration.loan'),
    event: 'Web_Filters_Loan',
  },
  inv: {
    param: 'inv',
    key: 3,
    text: t('components.header.filtersBar.filters.registration.inv'),
    event: 'Web_Filters_Inv',
  },
  buySale: {
    param: 'buySale',
    key: 9,
    text: t('components.header.filtersBar.filters.registration.buySale'),
    event: 'Web_Filters_Buy_Sale',
  },
  contract: {
    param: 'contract',
    key: 13,
    text: t('components.header.filtersBar.filters.registration.contract'),
    event: 'Web_Filters_Contract',
  },
  prec: {
    param: 'prec',
    key: 2,
    text: t('components.header.filtersBar.filters.registration.prec'),
    event: 'Web_Filters_Prec',
  },
  ust: {
    param: 'ust',
    key: 1,
    text: t('components.header.filtersBar.filters.registration.ust'),
    event: 'Web_Filters_Justice',
  },
  shared: {
    param: 'shared',
    key: 4,
    text: t('components.header.filtersBar.filters.registration.shared'),
  },
  reserv: {
    param: 'reserv',
    key: 5,
    text: t('components.header.filtersBar.filters.registration.reserv'),
  },
  partnership: {
    param: 'partnership',
    key: 7,
    text: t('components.header.filtersBar.filters.registration.partnership'),
  },
  assignment: {
    param: 'assignment',
    key: 8,
    text: t('components.header.filtersBar.filters.registration.assignment'),
  },
});

export const parseSearch = (search, t) => {
  const { registrations } = search;
  if (!registrations) {
    return { registrations: [] };
  }
  const keys = registrations.split(',');
  const variants = getVariants(t);
  return {
    registrations: Object.keys(variants).reduce((prev, cur) => {
      const variant = variants[cur];
      if (keys.includes(variant.param)) {
        prev.push(variant.key);
      }
      return prev;
    }, []),
  };
};

export const compileSearch = (data, t) => {
  const { registrations: keys } = data;
  if (!keys.length) {
    return { registrations: undefined, federalLaw: undefined };
  }

  const variants = getVariants(t);

  const compiled = {
    registrations:
      Object.keys(variants)
        .reduce((prev, cur) => {
          const variant = variants[cur];
          if (keys.includes(variant.key)) {
            prev.push(variant.param);
          }
          return prev;
        }, [])
        .join(',') || undefined,
  };

  // Добавляем параметр federalLaw если выбран ключ 14
  if (keys.includes(14)) {
    compiled.federalLaw = 'ФЗ-214';
  } else {
    compiled.federalLaw = undefined;
  }

  return compiled;
};

export const compileRequest = (data) => {
  const { registrations } = data;
  const request = { registrations: registrations.length ? registrations : undefined };

  // Добавляем параметр federalLaw если выбран ключ 14
  if (registrations.includes(14)) {
    request.federalLaw = ['ФЗ-214'];
  } else {
    request.federalLaw = undefined;
  }

  return request;
};

export const getRequest = (search) => compileRequest(parseSearch(search, i18n.t));

export const subtext = (search, t) => {
  const { registrations: keys } = parseSearch(search, t);
  const variants = getVariants(t);
  return (
    Object.keys(variants)
      .reduce((prev, cur) => {
        const variant = variants[cur];
        if (keys.includes(variant.key)) {
          prev.push(variant.text);
        }
        return prev;
      }, [])
      .join(', ') || null
  );
  // .join(', ') || i18n.t('components.header.filtersBar.filters.registration.notSelected');
};

class Registration extends Component {
  constructor(props) {
    super(props);

    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    this.handleClearClick = this.handleClearClick.bind(this);
  }

  handleClearClick() {
    const { dropdownData, profile, mode, objectType, t } = this.props;
    const data = { registrations: [] };
    const compiledSearch = compileSearch(data, t);
    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);

    trackGA(
      gaEvent.filterClearButtonsClick({
        eventContent: 'oformlenie',
        eventContext: mode,
        productType: objectType,
        user_id: profile.id,
      })
    );
  }

  handleCheckboxClick(key, add) {
    const { search, dropdownData, eventData, mode, objectType, profile, t } = this.props;
    const variants = getVariants(t);
    const { registrations: keys } = parseSearch(search, t);
    const registrations = [...keys];
    tracker.sendVariantEvent({ variants, key, selected: add, eventData });

    const variant = variants[Object.keys(variants).find((v) => variants[v].key === key)];
    const variantName = variant ? variant.text : 'Unknown variant';
    const isChecked = add ? 'on' : 'off';

    trackGA(
      gaEvent.filterCheckboxesClick({
        eventContent: [variantName, ` | ${isChecked}`],
        eventContext: mode,
        productType: objectType,
        user_id: profile.id,
      })
    );

    if (registrations.includes(key) !== add) {
      if (add) {
        registrations.push(key);
      } else {
        registrations.splice(registrations.indexOf(key), 1);
      }
    }

    const data = { registrations };
    const compiledSearch = compileSearch(data, t);
    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);
  }

  checkbox(key) {
    const { search, t } = this.props;
    const { registrations } = parseSearch(search, t);
    const variants = getVariants(t);
    const variant = variants[key];
    return (
      <Checkbox
        className={styles.Checkbox}
        innerStyle={styles.FiltersCheckInner}
        classNameClone="CheckboxCloneFilters"
        checked={registrations.includes(variant.key)}
        handle={this.handleCheckboxClick.bind(undefined, variant.key)}
        text={variants[key].text}
      />
    );
  }

  render() {
    const { className, additional, search, t } = this.props;
    const { registrations } = parseSearch(search, t);

    return (
      <div className={cn(styles.Menu, className, { [styles.Additional]: additional })}>
        <p className={styles.Title}>
          {t('components.header.filtersBar.filters.registration.title')}
          {!!registrations.length && (
            <Button className={styles.Button} onClick={this.handleClearClick}>
              {t('components.header.filtersBar.filters.registration.clear')}
            </Button>
          )}
        </p>
        <div className={styles.Checkboxes}>
          <div className={styles.FirstColumn}>
            {this.checkbox('part')}
            {this.checkbox('loan')}
            {this.checkbox('inv')}
            {this.checkbox('buySale')}
          </div>
          <div className={styles.SecondColumn}>
            {this.checkbox('contract')}
            {this.checkbox('prec')}
            {this.checkbox('ust')}
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(Registration);



// WEBPACK FOOTER //
// ./src/components/Header/FiltersBar/Filters/Registration/Registration.js